import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex);

const state = {
  userInfo:"",
	tabsArr:[],
  tabActiveId:null,
	openMenu:[],
  permissions:[],//权限列表
};

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js